/*! cookies.js */

import escapeStringRegExp from "escape-string-regexp";
import CookieExpirationDate from "./cookie-expiration-date";

const DEFAULT_COOKIE_PATH = "/";
const DEFAULT_SECURE_VALUE = false;
const DEFAULT_DOMAIN = "";

class Cookies {

    /**
     * Returns a cookie value
     * @param {String} cookieName
     * @returns {?string}
     */
    get(key) {
        const matches = document.cookie.match(`(^|;) ?${ escapeStringRegExp(key) }=([^;$]*)`);

        if (matches) {
            return decodeURI(matches[2]);
        }

        return undefined;
    }

    /**
     * Sets a cookie value
     * @param {String} cookieName
     * @param {String} value
     * @param {Boolean} encodeValue
     * @param {Object} options
     * @returns {?void}
     */
    set(cookieName, value, encodeValue, options) {
        const cookieOptions = this.getCookieOptions(options || {});
        value = encodeValue ? encodeURIComponent(value) : value;

        document.cookie = this.generateCookieString(cookieName, value, cookieOptions);
    }

    /**
     * Sets a cookie value
     * @param {String} cookieName
     * @param {Object} options
     * @returns {?void}
     */
    remove(cookieName, options) {
        const cookieOptions = this.getCookieOptions(options || {});
        cookieOptions.expires = new Date(-1).toGMTString();
        this.set(cookieName, "", false, cookieOptions);
    }

    /**
     * Generates a string to add to document.cookies
     * @param {String} cookieName
     * @param {string} value
     * @param {Object} options
     * @returns {?String}
     */
    generateCookieString(cookieName, value, options) {
        let cookieString = cookieName + "=" + value;
        cookieString += ";path=" + options.path;

        if (options.domain) {
            cookieString += ";domain=" + options.domain;
        }

        cookieString += options.expires ? ";expires=" + options.expires : "";
        cookieString += options.secure ? ";secure" : "";

        return cookieString;
    }

    /**
     * Generates a hashmap of the cookie options
     * @param {Object} options
     * @returns {?String}
     */
    getCookieOptions(options) {
        options = options || {};
        const expires = options && options.expires ? options.expires : null;

        return {
            path: options && options.path ? options.path : DEFAULT_COOKIE_PATH,
            domain: DEFAULT_DOMAIN,
            expires: CookieExpirationDate.stringInGMT(expires),
            secure: options.secure !== undefined ? options.secure : DEFAULT_SECURE_VALUE
        };
    }
}

export default new Cookies();
